@if (content) {
  <a role="button"
    [class]="'btn ' + cssClass"
    href="{{ href() }}"
    [attr.target]="content!.new_window ? '_blank' : undefined"
    (click)="onClick ? onClick($event) : undefined"
    >{{content!.label}}
  </a>
}